import React, {useState, useEffect} from 'react';
import { Typography, Button, FormGroup, FormControlLabel, Radio, FormControl, RadioGroup, Checkbox } from '@mui/material';
import '../styles/common.css';
import {rewardApplyApi} from './redux/actions';
import TickIcon from '../assets/tick.svg';
import ErrorInfo from '../assets/error-info.svg';
import { getCurrencyList, getIpBasedCurrency, redeemGivecardApi } from './redux/actions';
import * as formatters from '../utils/util';
import langDetails from '../components/MultiLanguage/language.json';
import DonationCost from './DonationCost';

const ApplyGivecard = ({ handleNext, sharedData, updateSharedData, onBackButtonClick }) => {

  const givecardData = JSON.parse(sessionStorage.getItem("giveCardDatas")) ?   JSON.parse(sessionStorage.getItem("giveCardDatas"))  :  null;

  const [isRedeemChecked, setIsRedeemChecked] = useState(false);

  const isLoggedin = sharedData?.userId && sharedData?.userId  !== "None"

  const [errorMessage, setErrorMessage] = useState('');
  const [errorMessage1, setErrorMessage1] = useState('');
  const [radioErrorMessage, setRadioErrorMessage] = useState('');
  const [selectedValue, setSelectedValue] = useState('');
  const [showBackButton, setShowBackButton] = useState(true);

  const [rewardCode, setRewardCode] = useState(sharedData?.rewardApplied?.rewardCode || '');

  const [amount, setAmount] = useState(sharedData?.donationAmount?.amount  || null);
  const [creditApplied, setCreditApplied] = useState(sharedData?.rewardApplied?.creditApplied + sharedData?.rewardApplied?.givacardBalance || 0);
  const [currency, setCurrency] = useState(sharedData?.donationAmount?.currency  || 'cad');
  const [totalAmount, setTotalAmount] = useState(sharedData?.donationAmount?.totalAmount  || 0);

  const [ipBasedCurrency, setIpBasedCurrency] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [countryCode, setCountryCode] = useState('')
  const [currencySymbol, setCurrencySymbol] = useState(null);
  const [giveCardBlc, setGiveCardBlc] = useState(sharedData?.rewardApplied?.givacardBalance || null);
  const [givecardId, setGiveCardId] = useState(sharedData?.rewardApplied?.givecardId || null)
  const [redeemableAmount, setRedeemableAmount] = useState(sharedData?.rewardApplied?.redeemableAmount);
  const [campaignName, setCampaignName] = useState(null);
  const [campaignMessage, setCampaignMessage] = useState(null);
  const [campaignImage, setCampaignImage] = useState(sharedData?.rewardApplied?.redeemableAmount || null);
  const [applyBtnDisable, setApplyBtnDisable] = useState(false);
  const [showRedeemSuccess, setShowRedeemSuccess] = useState(false);
  const lang = langDetails[sharedData?.language];

  useEffect(() => {
    getIpBasedCurrency().then((response) => {
        if(response.code && response.code  !== "") {
          return
        }
        if (response && response.status === 200) {
            setIpBasedCurrency(response.data.currency)
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setErrorMessage(error.message);
      });

      getCurrencyList().then((response) => {
        if(response.code && response.code  !== "") {
          return
        }
        if (response && response.status === 200) {
          setCurrencyList(response.data.data)
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setErrorMessage(error.message);
      });
  }, []);

  useEffect(() => {
    if (ipBasedCurrency?.length > 0 && currencyList?.length > 0) {
      const defaultCurrency = sharedData?.donationAmount?.currency || 'USD';

      setCurrencyList(currencyList);

      // For Current Use
      // setCountryCode(defaultCurrency);
      // setCurrency(defaultCurrency);
      // setCurrencySymbol(getCurrencySymbol(defaultCurrency));

      setCountryCode(sharedData?.donationAmount?.currency || ipBasedCurrency)
      setCurrency(sharedData?.donationAmount?.currency || ipBasedCurrency);
      setCurrencySymbol(sharedData?.donationAmount?.currency ? getCurrencySymbol(sharedData?.donationAmount?.currency) : getCurrencySymbol(ipBasedCurrency))
    }
  }, [ipBasedCurrency, currencyList]);


  const getCurrencySymbol = (currencyCode) => {
    const currency = currencyList?.find((item) => item.currencyCode === currencyCode);
    return currency ? currency.currencySymbol : '';
  };

  const handleRewardChange = (e) => {
    setErrorMessage('')
    let inputValue = e.target.value;
    if (/^[a-zA-Z0-9]*$/.test(inputValue) || inputValue === '') {
      setRewardCode(inputValue);
    }
  };

  const handleApplyReward = () => {
    let isValid = false;
    if(rewardCode?.trim()?.length === 0){
      setErrorMessage(lang?.pleaseEnterPin)
        isValid = true;
    } 
    if(isValid) {
      return
    }
    const payload = {
      "code": rewardCode?.toUpperCase(),
      "userId": sharedData?.userId  !== "None"  ? sharedData?.userId : null,
      "supplierId": sharedData?.supplier_id || null,
      "languageCode": sharedData?.language || "en"
    }
    onApplyReward(payload);
  };
 
  const onApplyReward = (apiReq) => {
    rewardApplyApi(apiReq).then((response) => {
      setErrorMessage('')
      if(response.code && response.code  !== "") {
        setErrorMessage(response.code);
        return
      }
      if (response && response.data && response.data.status === 200) {
          sessionStorage.removeItem("sharedData");
          setErrorMessage('')
          setShowBackButton(!showBackButton);
          onBackButtonClick(!showBackButton);
          setCreditApplied(response.data?.data?.balance);
          setGiveCardBlc(response.data?.data?.balance);
          setGiveCardId(response.data?.data?.givecardId);
          setShowRedeemSuccess(true);
          setTotalAmount(response.data?.data?.balance + amount);
          setCampaignName(response.data?.data?.campaignName);
          setCampaignImage(response.data?.data?.campaignImage);
          setCampaignMessage(response.data?.data?.campaignMessage);
      }
      if (response && response.data && response.data.status !== 200) {
        setErrorMessage(response.data.message);
      }
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
      setErrorMessage(error.message);
    });
  }
  const onChangeInput = (e) => {
    let val = formatters.isNumeric(e.target.value);
    const enteredAmount = Number(val);
    setErrorMessage1("")
    if(enteredAmount <= creditApplied) {
      setGiveCardBlc(creditApplied - val)
      setRedeemableAmount(val);
    } else {
      setGiveCardBlc(creditApplied)
      setRedeemableAmount('');
    }
  }
  const onChangeInputForUseBlc = (e) => {
    let val = formatters.isNumeric(e.target.value);
    let balancAmt = sharedData?.applyCardData?.givacardBalance || givecardData?.givacardBalance
    const enteredAmount = Number(val);
    setErrorMessage1("")
    if(enteredAmount === 0 ) { 
      setGiveCardBlc(balancAmt)
      setRedeemableAmount('');
      return;
    } else if(enteredAmount <= balancAmt) {
      setGiveCardBlc(balancAmt - val)
      setRedeemableAmount(val);
    } else {
      setGiveCardBlc(balancAmt)
      setRedeemableAmount('');
    }
  }

  const onNextClick = () => {
    
    const rewardApplied = {
      "creditApplied": Number(redeemableAmount) || 0,
      "redeemableAmount": Number(redeemableAmount) || 0,
      "rewardCode": errorMessage ? '' : rewardCode,
      "givecardId": givecardId || sharedData?.applyCardData?.givecardId || givecardData?.givecardId ,
      "givacardBalance": giveCardBlc,
      "showGiveCardBlc": true
     }
    const updatedData = { ...sharedData, rewardApplied };
    updateSharedData(updatedData);
    // if(selectedValue === 'pin') {
      if(!redeemableAmount || Number(redeemableAmount) <=  0)  {
        setErrorMessage1(lang?.pleaseEnterValidAmount);
        return
      }
      setErrorMessage1("");
      const payload = {
        "givecardId": givecardId || sharedData?.applyCardData?.givecardId || givecardData?.givecardId || null,
        "userId": sharedData?.userId  !== "None"  ? sharedData?.userId : null,
        "givacardBalance": giveCardBlc,
        "supplierId": sharedData?.supplier_id || "",
        "givecardAmount": Number(redeemableAmount) || 0,
        "currency": currency,
        "projectId":sharedData?.projectId || ""
      }
      onRedeemingGivecard(payload, selectedValue);
    // } else {
      // handleNext();
    // }
  }
  const onRedeemingGivecard = (apiReq, val) => {
    redeemGivecardApi(apiReq).then((response) => {
      setErrorMessage('')
      if(response.code && response.code  !== "") {
        setErrorMessage(response.code);
        return
      }
      if (response && response.data && response.data.status === 200) {
        
        const applyCardData = {
          selectedValue: "pin",
          "creditApplied": Number(redeemableAmount) || 0,
          "redeemableAmount": Number(redeemableAmount) || 0,
          "rewardCode": errorMessage ? '' : rewardCode,
          "givecardId": givecardId ||  sharedData?.applyCardData?.givecardId || givecardData?.givecardId || null,
          "givacardBalance": giveCardBlc,
          "showGiveCardBlc": true,
          moreProjectUrl: response?.data?.data?.moreProjectUrl,
          exclusiveContentUrl: response?.data?.data?.exclusiveContentUrl,
          createdTime: response?.data?.data?.createdTime,
          moreProjectLabelName: response?.data?.data?.moreProjectLabelName,
          exclusiveContentLabelName: response?.data?.data?.exclusiveContentLabelName
        }
        const updatedData = { ...sharedData, applyCardData };
        updateSharedData(updatedData);
        sessionStorage.removeItem("giveCardDatas");
        var data = {
          "givacardBalance": giveCardBlc,
          "givecardId": givecardId ||  sharedData?.applyCardData?.givecardId || givecardData?.givecardId || null,
        };
        window.parent.postMessage({ message: "givecardInfo", data: data }, "*");
        sessionStorage.removeItem("sharedData");
        handleNext(3);
      }
      if (response && response.data && response.data.status !== 200) {
        setErrorMessage(response.data.message);
      }
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
      setErrorMessage(error.message);
    });
  }
  const onRedeemBtnClick = (event, val)=> {
    event.preventDefault();
    setSelectedValue(val);
    setShowRedeemSuccess(false)
  }
  return (
    <>
    {showRedeemSuccess && (
    <div>
        <div className='flex-space-btw' style={{alignItems: 'center'}}>
          <Typography className="query-head">{lang?.pinRedeemed}!</Typography>
          {/* <Typography className="sub-head" style={{display: 'flex', alignItems: 'center'}}><img width={12} height={12} src={TickIcon} style={{ marginRight: 5 }} />{rewardCode?.toUpperCase()}</Typography> */}
          <Typography className="normal-text" style={{display: 'flex', alignItems: 'center'}}>{currencySymbol}{giveCardBlc ? giveCardBlc : 0}&nbsp;{lang?.balance}</Typography>
        </div>
        
        <div className='flex-space-btw mt-40' style={{alignItems: 'center', justifyContent: 'center', gap: 32}}>
            <div className='image-div'><img src={campaignImage}/></div>
            <div>
              <Typography className="sub-head mb-10">{campaignName} {lang?.hasGivenYou} {currencySymbol}{giveCardBlc ? giveCardBlc : 0}</Typography>
              <Typography className="normal-text">{campaignMessage}</Typography>
            </div>
        </div>
        <div className="normal-text mb-10 ">
          <Typography className='sub-head mb-10 mt-20'>{lang?.howMuchPin}</Typography>
          <div className='apply-amount'>
            <input className='amount-input' value={redeemableAmount} onChange={onChangeInput} placeholder={lang?.redeemableAmt} name={lang?.redeemableAmt} />
            <div style={{position: 'absolute', top:'13px',right:10}}>({currencySymbol}{giveCardBlc} Max)</div>
          </div>
          {errorMessage1 !== '' && (<p className="normal-text" id="err-msg" style={{color:'#FF0000', display:'flex', alignItems:'center',gap:10}}><img class="" height="15px" width="15px" src={ErrorInfo} /> {errorMessage1}</p>)}
        </div>
        <Button className="normal-text next-btn mb-10 mt-40" variant='contained' onClick={onNextClick}>
          {lang?.donatePin}
        </Button>
        
        {/* <div className='flex-space-btw mt-40' style={{marginTop: 10, marginBottom: 15}}>
          <Typography className="normal-text mb-10"><b>{lang?.pinCreditApplied}</b></Typography>
          <Typography className="normal-text mb-10"><b>{currencySymbol}{creditApplied ? creditApplied : 0.00}</b></Typography> */}
        {/* </div> */}
        {/* <div className='flex-space-btw'>
            <Typography className="normal-text mb-10">{lang?.yourDonation}</Typography>
            <Typography className="normal-text mb-10">{currencySymbol}{0.00}</Typography>
        </div>
        <div className='flex-space-btw' style={{marginBottom: 15}}>
            <Typography className="sub-head mb-10">{lang?.total}</Typography>
            <Typography className="sub-head mb-10" style={{textTransform: 'uppercase'}}>{currency} {currencySymbol}{totalAmount ? totalAmount : 0.00}</Typography>
        </div> */}
        {/* <Button className="normal-text next-btn mb-10" variant='contained' onClick={(e)=>{onRedeemBtnClick(e, 'pin');}}>
          {lang?.onlyDonatePinCredit}
        </Button>
        <Button className="lg-medium-text outlined-black-btn mb-20" style={{textTransform: 'capitalize', borderRadius: 12, backgroundColor: '#fff', width: '100%'}} variant='outlined' onClick={(e)=>{onRedeemBtnClick(e, 'funds');}}>
          {lang?.addAdditionalDonation}
        </Button> */}
    </div>
    )}
  {!showRedeemSuccess && (
    <div>
       {creditApplied === 0 && !sharedData?.rewardApplied?.givecardId && (
        <>
            {/* <Typography className='query-head mb-40'>{lang?.howMuchWouldYouLikeToDonate}</Typography> */}
            {((isLoggedin && sharedData?.applyCardData?.selectedValue === 'pin'  && sharedData?.applyCardData?.givacardBalance > 0) || (isLoggedin && givecardData?.selectedValue === 'pin'  && givecardData?.givacardBalance > 0)) ? (
                <div className='apply-box'>
                  <div className='' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <FormGroup>
                      <FormControlLabel control={
                        <Checkbox
                        checked={isRedeemChecked}
                        size="small" 
                        sx={{
                          color: "#5D4294",
                          '&.Mui-checked': {
                            color: "#5D4294",
                          },
                        }}
                      
                        onChange={() => setIsRedeemChecked(!isRedeemChecked)}
                      />
                      } label={<Typography className="sub-head">{lang?.usePinBalance}</Typography> } />
                    </FormGroup>
                      
                    <Typography className="sub-head mb-10" style={{color: 'rgba(93, 66, 148, 1)' }}>{`$${sharedData?.applyCardData?.givacardBalance || givecardData?.givacardBalance}`}</Typography>
                    {creditApplied !== 0 && (<Typography className="sub-head mb-10" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textTransform: 'uppercase' }}><img src={TickIcon} style={{ marginRight: 5 }} />{rewardCode} </Typography>)}
                  </div>
                  <>
                  {isRedeemChecked && (
                  <><Typography className="normal-text mb-10">{lang?.howMuchPin}</Typography><div className='apply-amount'>
                          <input className='amount-input placeholder-text sub-head'
                            type="text"
                            placeholder={`$${sharedData?.applyCardData?.givacardBalance || givecardData?.givacardBalance} (Default)`}
                            style={{ textTransform: 'uppercase' }}
                            value={redeemableAmount} 
                            onChange={onChangeInputForUseBlc}
                            // value={rewardCode}
                            // maxLength={6}
                            // onChange={handleRewardChange} 
                            />
                            {errorMessage1 !== '' && (<p className="normal-text" id="err-msg" style={{color:'#FF0000', display:'flex', alignItems:'center',gap:10}}><img class="" height="15px" width="15px" src={ErrorInfo} /> {errorMessage1}</p>)}
                          <Button className="normal-text apply-btn"  style={{ textTransform: 'capitalize', borderRadius: 10, backgroundColor: rewardCode?.length === 6 ? '#000' : '#ADADAD' }} onClick={onNextClick} variant='contained'>
                           {lang?.donatePin}
                          </Button>
                        </div></>
                  )}
                      {errorMessage !== '' && (<p className="normal-text mt-0" id="err-msg" style={{ color: '#FF0000', display: 'flex', alignItems: 'center', gap: 10 }}><img class="" height="15px" width="15px" src={ErrorInfo} /> {errorMessage}</p>)}
                  </>
                  </div>   

            ) : (
                <div className='apply-box'>
                  <div className='' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <FormGroup>
                      <FormControlLabel control={
                        <Checkbox
                        checked={isRedeemChecked}
                        size="small" 
                        sx={{
                          color: "#5D4294",
                          '&.Mui-checked': {
                            color: "#5D4294",
                          },
                        }}
                      
                        onChange={() => setIsRedeemChecked(!isRedeemChecked)}
                      />
                      } label={<Typography className="sub-head">{lang?.redeemAPin}</Typography> } />
                    </FormGroup>
                      
                    {/* <Typography className="sub-head mb-10">{lang?.redeemAPin}:</Typography> */}
                    {creditApplied !== 0 && (<Typography className="sub-head mb-10" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textTransform: 'uppercase' }}><img src={TickIcon} style={{ marginRight: 5 }} />{rewardCode} </Typography>)}
                  </div>
                  <>
                  {isRedeemChecked && (
                  <div className='apply-amount'>
                    <input className='amount-input placeholder-text sub-head'
                      type="text"
                      placeholder={lang?.enter6digitPin}
                      style={{ textTransform: 'uppercase' }}
                      value={rewardCode}
                      maxLength={6}
                      onChange={handleRewardChange} />
                    <Button className="normal-text apply-btn" disabled={rewardCode?.length !== 6} style={{ textTransform: 'capitalize', borderRadius: 10, backgroundColor: rewardCode?.length === 6 ? '#000'  : '#ADADAD' }} onClick={handleApplyReward} variant='contained'>
                      {lang?.apply}
                    </Button>
                  </div>
                  )}
                      {errorMessage !== '' && (<p className="normal-text mt-0" id="err-msg" style={{ color: '#FF0000', display: 'flex', alignItems: 'center', gap: 10 }}><img class="" height="15px" width="15px" src={ErrorInfo} /> {errorMessage}</p>)}
                  </>
                  </div>
            )}
                      
          </>
        )
        //  : (
        //   <>
        //   <div className='' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        //       <Typography className="sub-head mb-10">{lang?.redeemedPIN}:</Typography>
        //       {creditApplied !== 0 && (<Typography className="sub-head mb-10" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textTransform: 'uppercase' }}><img src={TickIcon} style={{ marginRight: 5 }} />{rewardCode} </Typography>)}
        //     </div>
        //     <div className='flex-space-btw mt-10'>
        //       <Typography className="normal-text mb-10">{lang?.pinBlc}</Typography>
        //       <Typography className="normal-text mb-10">{currencySymbol}{giveCardBlc ? giveCardBlc : 0.00}</Typography>
        //     </div>
        //     <div className='mb-40' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        //       <div className=''>{lang?.howMuchPin}?</div>
        //       <div className="normal-text">
        //         <input className='amount-input w-50' value={redeemableAmount} onChange={onChangeInput} style={{ textAlign: 'right' }} placeholder={lang?.redeemableAmt} name={lang?.redeemableAmt} />
        //         {errorMessage1 !== '' && (<p className="normal-text" id="err-msg" style={{color:'#FF0000', display:'flex', alignItems:'center',gap:10}}><img class="" height="15px" width="15px" src={ErrorInfo} /> {errorMessage1}</p>)}
        //       </div>
        //     </div>
        //   </>
        // )
        }
        <DonationCost handleNext={handleNext} sharedData={sharedData} updateSharedData={updateSharedData}/>

        {/* {creditApplied !== 0 ? (
          
          <div className='flex-space-btw mt-10 mb-10'>
            <Typography className="normal-text mb-10"><b>{lang?.pinCreditApplied}</b></Typography>
            <Typography className="normal-text mb-10"><b>{currencySymbol}{redeemableAmount ? redeemableAmount : 0.00}</b></Typography>
          </div>
        ) : <div style={{ height: 60 }}></div>}
        <Button className="normal-text next-btn" variant='contained' onClick={onNextClick}>
          {selectedValue && selectedValue === 'pin' ? lang?.giveNow : selectedValue === 'funds' ?  lang?.next : lang?.continueWithoutPIN}
        </Button> */}
      </div>
  )}
      </>
  );
}

export default ApplyGivecard;

